// components/EventLogForm.tsx
import React from "react";
import { TextField, Button } from "@mui/material";

interface EventLogFormProps {
  notes: string;
  onChange: {
    setNotes: (v: string) => void;
  };
  onSubmit: (e: React.FormEvent) => void;
}

export default function EventLogForm({
  notes,
  onChange,
  onSubmit,
}: EventLogFormProps) {
  return (
    <form onSubmit={onSubmit}>

      <TextField
        label="Notes"
        value={notes}
        onChange={(e) => onChange.setNotes(e.target.value)}
        fullWidth
        margin="normal"
        multiline
        rows={3}
      />

      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 2 }}
      >
        Submit
      </Button>
    </form>
  );
}
